import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll when the route path changes (including back/forward), so every page
 * opens at the top. Query-only changes (e.g. tab params) don't scroll.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Stop the browser from restoring the old offset on back/forward.
    window.history.scrollRestoration = "manual";
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
